import EnvironmentConfig from '~/config/environment_config'

export default async ({ _route }, inject) => {
  const environmentConfig = new EnvironmentConfig()
  await environmentConfig.loadConfigAsync()
  inject('environmentConfig', environmentConfig)
}
